import ct from "class-types.macro";

export const innerClasses = `${ct(
  "flex",
  "transform",
  "transition",
  "duration-300"
)} inner-banner`;
export const pagerContainerClasses = ct("inline-block", "text-center");
export const pagerClasses = ct(
  "rounded-full",
  "border-0",
  "inline-block",
  "h-4",
  "mx-1",
  "overflow-hidden",
  "p-0",
  "text-transparent",
  "w-4"
);
